import GeneratedAddressBookStore from "./generated/GeneratedAddressBookStore"

class AddressBookStore extends GeneratedAddressBookStore {

}

export const addressBookStore = new AddressBookStore()
